import { z } from 'zod';

export const companySiteDefaultSchema = z.object({
  id: z.string(),
  name: z.string(),
  companyID: z.string(),
});

export const getCompanySitesSchema = z.array(companySiteDefaultSchema);

export type GetCompanySitesResponse = z.infer<typeof getCompanySitesSchema>;
